// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  shadowRunId: __t.u64().primaryKey().name("shadow_run_id"),
  workspaceId: __t.u64().name("workspace_id"),
  sourceKind: __t.string().name("source_kind"),
  sourceId: __t.u64().name("source_id"),
  teamRecipeJson: __t.string().name("team_recipe_json"),
  personaContractVersionsJson: __t.string().name("persona_contract_versions_json"),
  modelVersionsJson: __t.string().name("model_versions_json"),
  harness: __t.string(),
  budgetMicros: __t.i64().name("budget_micros"),
  status: __t.string(),
  spentMicros: __t.i64().name("spent_micros"),
  receiptIdsJson: __t.string().name("receipt_ids_json"),
  createdAt: __t.i64().name("created_at"),
  updatedAt: __t.i64().name("updated_at"),
  completedAt: __t.option(__t.i64()).name("completed_at"),
  error: __t.option(__t.string()),
});
